export { default } from './Congrats.container';
